import { createSlice } from "@reduxjs/toolkit";

const mapSettingsSlice = createSlice({
  name: "mapSettings",
  initialState: {
    locationTradeAreaSetting: {
      radiusSetting: [
        {
          id: "0",
          type: "",
          order: "0",
          defaultRadius: 0.25,
          defaultRingRadiusColor: "#2EDED2",
          defaultDriveTimeColor: "#17BA49",
          defaultRingRadiusBorder: "#000000",
          defaultDriveTimeBorder: "#000000",
          defaultBorderWidth: 3,
          defaultOpacity: 1,
          isTransparent: true,
          isBorderTransparent: false,
        },
        {
          id: "1",
          type: "",
          order: "1",
          defaultRadius: 0.5,
          defaultRingRadiusColor: "#F7A504",
          defaultDriveTimeColor: "#17BA49",
          defaultRingRadiusBorder: "#000000",
          defaultDriveTimeBorder: "#000000",
          defaultBorderWidth: 3,
          defaultOpacity: 1,
          isTransparent: true,
          isBorderTransparent: false,
        },
        {
          id: "2",
          type: "",
          order: "2",
          defaultRadius: 0.75,
          defaultRingRadiusColor: "#FF0000",
          defaultDriveTimeColor: "#17BA49",
          defaultRingRadiusBorder: "#000000",
          defaultDriveTimeBorder: "#000000",
          defaultBorderWidth: 3,
          defaultOpacity: 1,
          isTransparent: true,
          isBorderTransparent: false,
        },
        {
          id: "3",
          type: "",
          order: "3",
          defaultRadius: 1,
          defaultRingRadiusColor: "#2EDED2",
          defaultDriveTimeColor: "#17BA49",
          defaultRingRadiusBorder: "#000000",
          defaultDriveTimeBorder: "#000000",
          defaultBorderWidth: 3,
          defaultOpacity: 1,
          isTransparent: true,
          isBorderTransparent: false,
        },
      ],
      pointers: [
        {
          name: "fa-solid fa-location-pin",
          color: "#fffd54",
          size: 30,
        },
        {
          name: "fa-solid fa-location-dot",
          color: "#fffd54",
          size: 30,
        },
        {
          name: "fa-regular fa-location-plus",
          color: "#fffd54",
          size: 30,
        },
      ],
    },
    logoSetting: {
      logoLeaderLineColor: "#FFFFFF",
      logoBackgroundColor: "#FFFFFF",
      logoLeaderLineBorderWidth: 2,
      imageSize: ["Small", "Medium", "Large"],
      logoWidthAndHeight: "60px",
      logoHaloEffect: "#ffffff",
      logoHaloEffect_x: 0,
      logoHaloEffect_y: 0,
      logoHaloEffect_b: 0,
      logoHaloEffect_c: 0,
      isBackgroundColorTransparent: false,
      logoHaloEffectTransparent: false,
      width: "60px",
      height: "60px",
    },
    shapeSetting: {
      borderColor: "#ffffff",
      backgroundColor: "#ffffff",
      borderWidth: "2",
    },
    textBoxSetting: {
      textBoxFontColor: "#00000080",
      textBoxFontFamily: "Arial",
      textBoxFontSize: 20,
      textBoxFontStyle: "none",
      textBoxFontAlignment: "left",
      textBoxFillColor: "#808080",
      textBoxBorderColor: "#b5ef9d",
      textBoxBorderWidth: 2,
      textBoxOpacity: 50,
      textBoxHaloEffect: "#de00ff",
      textBoxHaloEffect_x: 0,
      textBoxHaloEffect_y: 0,
      textBoxHaloEffect_b: 0,
      textBoxDropShadow: "#363636",
      textBoxDropShadow_x: 0,
      textBoxDropShadow_y: 0,
      textBoxDropShadow_b: 0,
      leaderLineColor: "#000000",
      leaderLineWidth: 2,
      height: "75px",
      width: "200px",
      isBackgroundColorTransparent: true,
      rotate: 0,
    },
    poiSetting: {
      poiBackgroundColor: "#FFFFFF",
      poiBackgroundTransparent: false,
      poiWidthAndHeight: "80px",
      poiHaloEffectTransparent: false,
      poiHaloEffect: "#ffffff",
      poiHaloEffect_x: 7,
      poiHaloEffect_y: 7,
      poiHaloEffect_b: 3,
      poiHaloEffect_c: 0,
      poiLeaderLineColor: "#FFFFFF",
      poiLeaderLineBorderWidth: 2,
      poiCallOut: "no-callout",
      showLeaderLine: true,
    },
    highwaySetting: {
      highwayColor: "#7ED957",
      highwaySize: 5,
      highwayOpacity: 1,
    },
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {
    setPoiSetting: (state, action) => {
      state.poiSetting = action.payload;
    },
    updatePOISetting: (state, action) => {
      const payLoad = action.payload;
      return {
        ...state,
        poiSetting: {
          ...state.poiSetting,
          [payLoad.name]: payLoad.value,
        },
      };
    },
    setHighwaySetting: (state, action) => {
      state.highwaySetting = action.payload;
    },
    updateHighwaySetting: (state, action) => {
      const payLoad = action.payload;
      return {
        ...state,
        highwaySetting: {
          ...state.highwaySetting,
          [payLoad.name]: payLoad.value,
        },
      };
    },
  },
});

export const {
  setPoiSetting,
  updatePOISetting,
  setHighwaySetting,
  updateHighwaySetting,
} = mapSettingsSlice.actions;

export default mapSettingsSlice.reducer;
